import React from 'react';
import { StatusBadge } from './StatusBadge';
import { formatPeriodLabel } from './periodFormat';

const TYPE_LABELS = { kpi: 'KPI', performance: 'Performance Data', report: 'Report' };

export function SubmissionsTable({ rows, onEdit, onSubmit, onDelete, onView, emptyText = 'Nothing here yet.' }) {
  if (!rows || rows.length === 0) {
    return <p className="submissions-empty">{emptyText}</p>;
  }
  return (
    <table className="submissions-table">
      <thead>
        <tr><th>Type</th><th>Period</th><th>System</th><th>Status</th><th>Updated</th><th>Actions</th></tr>
      </thead>
      <tbody>
        {rows.map((r) => (
          <React.Fragment key={r.id}>
            <tr>
              <td>{TYPE_LABELS[r.type] || r.type}</td>
              <td>{formatPeriodLabel(r.period, r.period_start, r.period_end)}{r.countries?.name ? ` · ${r.countries.name}` : ''}</td>
              <td>{r.kpi_systems?.name || r.pi_systems?.name || r.report_systems?.name || '—'}</td>
              <td><StatusBadge status={r.status} /></td>
              <td>{r.updated_at ? r.updated_at.slice(0, 10) : ''}</td>
              <td className="submissions-actions">
                {(r.status === 'draft' || r.status === 'rejected') && (
                  <>
                    <button type="button" className="btn-secondary" onClick={() => onEdit(r)}>Edit</button>
                    <button type="button" className="btn-edit" onClick={() => onSubmit(r)}>
                      {r.status === 'rejected' ? 'Re-submit' : 'Submit'}
                    </button>
                  </>
                )}
                {r.status === 'draft' && (
                  <button type="button" className="btn-secondary" onClick={() => onDelete(r)}>Delete</button>
                )}
                {(r.status === 'submitted' || r.status === 'approved') && (
                  <button type="button" className="btn-secondary" onClick={() => onView(r)}>View</button>
                )}
              </td>
            </tr>
            {r.status === 'rejected' && r.review_comment && (
              <tr className="submissions-note-row">
                <td colSpan={6}><strong>Reviewer note:</strong> {r.review_comment}</td>
              </tr>
            )}
          </React.Fragment>
        ))}
      </tbody>
    </table>
  );
}
